import {AxiosResponse} from "axios";

import Api from "./api";
import {FactorySession, GetItemsResponse} from "../types";
import {prepareQueryParams} from "../utils/requests-utils";

export interface GetFactorySessionsParams {
    page?: number
    pageSize?: number
    workerId?: number | null
    family?: string | null
    overall?: string | null
    // Serial prefix, case-insensitive
    serial?: string | null
    // ISO dates, compared to startedAt (or createdAt when missing)
    dateFrom?: string | null
    dateTo?: string | null
}

interface GetFactorySessionResponse {
    session: FactorySession
}

export const getFactorySessions = (params: GetFactorySessionsParams = {}): Promise<AxiosResponse<GetItemsResponse<FactorySession>>> => {
    // The endpoint takes plain query params, not filter_fields / filter_values
    const req = {
        ...prepareQueryParams({page: params.page, pageSize: params.pageSize}),
        ...(params.workerId ? {worker_id: params.workerId} : {}),
        ...(params.family ? {family: params.family} : {}),
        ...(params.overall ? {overall: params.overall} : {}),
        ...(params.serial ? {serial: params.serial} : {}),
        ...(params.dateFrom ? {date_from: params.dateFrom} : {}),
        ...(params.dateTo ? {date_to: params.dateTo} : {}),
    }
    return Api.get('/admin/factory/sessions', {params: req})
}

export const getFactorySession = (sessionId: string): Promise<AxiosResponse<GetFactorySessionResponse>> => {
    return Api.get(`/admin/factory/sessions/${sessionId}`)
}
